import * as Reflux from "reflux";

/**
 * Actions handled by the CheckoutAggregatorStore
 */
export const CheckoutAggregatorActions = {
	onLoadCheckout: Reflux.createAction(["onLoadCheckout"]),
	onResetState: Reflux.createAction(["onResetState"]),
};
